function injectStyle (ssrContext) {
  require("!!../../../../nonameapp-customer/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../nonameapp-customer/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-278de048\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../nonameapp-customer/node_modules/vue-loader/lib/selector?type=styles&index=0!./Container.vue")
}
var normalizeComponent = require("!../../../../nonameapp-customer/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../nonameapp-customer/node_modules/vue-loader/lib/selector?type=script&index=0!./Container.vue"
import __vue_script__ from "!!babel-loader!../../../../nonameapp-customer/node_modules/vue-loader/lib/selector?type=script&index=0!./Container.vue"
/* template */
import __vue_template__ from "!!../../../../nonameapp-customer/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-278de048\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../nonameapp-customer/node_modules/vue-loader/lib/selector?type=template&index=0!./Container.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-278de048"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/components/Container/Container.vue
// module id = null
// module chunks = 